import { render, staticRenderFns } from "./RenewalRecord.vue?vue&type=template&id=ba4fc6c4&scoped=true"
import script from "./RenewalRecord.vue?vue&type=script&lang=js"
export * from "./RenewalRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4fc6c4",
  null
  
)

export default component.exports